/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import JournalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import MedicinesReconciliationChangedJeournalEvent from "parog-web/models/medicines-reconciliation-changed-journal-event";
export default class MedicinesReconciliationFormComponent extends JournalEventBasedComponent {
  static forcDisplayName =
    "Conciliation pharmaceutique et éducation thérapeutique";
  static fullComponentId = "medicines-reconsiliation/edition-form";

  static journalEventClass = MedicinesReconciliationChangedJeournalEvent;
  journalEventProperties = [
    "occurredAt",
    "medicinesReconciliation",
    "educationalTherapy"
  ];

  retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceOrLastJournalEvent;

  computePayload() {
    const payload = super.computePayload();
    payload.occurredAt = new Date();
    return payload;
  }
}
